import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {Category2, IAppSettingsWrap, ICategoryValues, IGlobalSettings, ISocialToken} from "../../../../interfaces";
import {Router} from "@angular/router";
import {compareIds, isHostLocal, isNullOrUndef, isNullOrUndefOrEmpty, popupWindow} from "../../../../common";
import {ToastrService} from "ngx-toastr";
import {DialogTokenTreeviewComponent} from '../../dialog-token-treeview/dialog-token-treeview.component';
import {animate, style, transition, trigger} from "@angular/animations";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {AppService, ContainerService, LocalStoreService, StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {IBlockLabelsRecords, MimeAnomalyType} from "../block-constants";
import {timeout} from "../../../../decorators/timeout";
import {DynamicFormComponent} from "../../../../components/dynamics/dynamic-form/dynamic-form.component";
import {ICategoryCheckItemNode} from '../../../../components/category-tree/tree-service/tree-data.model';
import {actionSceneJumpLinked} from "../../../../store/actions/user.actions";
import {FieldConfig} from 'app/interfaces/field.interface';
import {take} from 'rxjs/operators';
import {Validators} from "@angular/forms";
import * as _ from 'lodash';
import {isArray} from 'lodash';
import {ActionsSubject} from "@ngrx/store";
import {DialogCorsComponent} from "../../../../components/dialog-cors/dialog-cors.component";

interface ITokenItems {
    name: string;
    id: string;
    mimeType?: string;
}

interface TokenValue {
    id?: string;   // google drive
    path?: string; // drive / dropbox
}

const rssLinks = {
    custom: 'custom',
    embedded: 'embedded',
    'http://rss.news.yahoo.com/rss/world': 'World',
    'http://rss.news.yahoo.com/rss/iraq': 'Iraq',
    'http://rss.news.yahoo.com/rss/sports': 'Sports',
    'http://rss.news.yahoo.com/rss/highestrated Most': 'Recommended',
    'http://rss.news.yahoo.com/rss/topstories': 'Top Stories',
    'http://rss.news.yahoo.com/rss/us': 'U.S. National',
    'http://rss.news.yahoo.com/rss/elections': 'Elections',
    'http://rss.news.yahoo.com/rss/terrorism': 'Terrorism',
    'http://rss.news.yahoo.com/rss/mideast': 'Mideast Conflict',
    'http://rss.news.yahoo.com/rss/politics': 'Politics',
    'http://rss.news.yahoo.com/rss/business': 'Business',
    'http://rss.news.yahoo.com/rss/tech': 'Technology',
    'http://rss.news.yahoo.com/rss/entertainment': 'Entertainment',
    'http://rss.news.yahoo.com/rss/health': 'Health',
    'http://rss.news.yahoo.com/rss/oddlyenough': 'Odd News',
    'http://rss.news.yahoo.com/rss/science': 'Science',
    'http://rss.news.yahoo.com/rss/oped': 'Opinion/Editorial',
    'http://rss.news.yahoo.com/rss/obits': 'Obituaries',
    'http://rss.news.yahoo.com/rss/mostemailed': 'Most Emailed',
    'http://rss.news.yahoo.com/rss/mostviewed': 'Most Viewed',
    'http://rss.news.yahoo.com/rss/highestrated': 'Most Recommended'
};

// NETFEED_NEWS and NETFEED_HOROSCOPE removed, to restore, see older branches

@Component({
    selector: 'app-block-json',
    templateUrl: './block-json.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./block-json.component.scss'],
    // host: {'unique-binding': _.uniqueId('comp_id')},
    animations: [
        trigger('fadeInProperty', [
            transition(':enter', [
                style({opacity: 0}),
                animate('300ms', style({opacity: 1}))
            ])
        ])
    ],
})
export class BlockJsonComponent extends BlockBaseComponent {

    @ViewChild('dynamicFormComponent')
    dynamicFormComponent: DynamicFormComponent;

    // selectionModel: SelectionModel<number>;
    // categoryValues: Array<ICategoryValues>;
    videoized = false;
    tokenItems: Array<ITokenItems> = [];

    tokenFieldName = 'token';
    totalStockSymbols = 0;
    assignedScene;
    categoryValues: Array<ICategoryValues>;
    categoryTreeItems: Array<ICategoryCheckItemNode>;
    selectedCategories: Array<Category2> = [];
    selectedTokenValue: TokenValue = {id: '', path: ''};
    coreAppData: IAppSettingsWrap;
    scenesSimple: { name, sceneId }  [];
    serverEndPoint;
    childEndPoint;
    tokenType;
    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];
    rssNames = [];
    netFeedNewsLinks = [];
    netFeedHoroscopeLinks = [];
    defaultStocks = ['DOW, ^IXIC, ^GSPC, ^TNX, ^FTSE, ^GDAXI, ^FCHI, ^N225, ^HSI, ^STI'];
    transitionsEnabled = '0';
    enterprise: boolean;
    tokenized: boolean;
    socialized: boolean;
    socialKey: ISocialToken;

    constructor(
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private containerService: ContainerService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private actionsSubj: ActionsSubject,
        private router: Router,
        private appService: AppService,
        private toastr: ToastrService,
        protected override localStoreService: LocalStoreService
    ) {
        super(storeSelector, dialog);
        this.transitionsEnabled = this.localStoreService.getStorageValConfig('transitionsEnabled');
    }

    override onInit() {
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => {
                    this.enterprise = i_coreData[0].enterprise;
                    this.coreAppData = i_coreData;
                })
        );
    }

    override preInit() {
        super.preInit();
        switch (this.handleMimeAnomalies()) {
            case "STOCKS": {
                break;
            }
            case "XML": {
                break;
            }
            case "CATALOG": {
                this.cod(
                    this.storeSelector.getCatalogValues().subscribe((v: ICategoryValues[]) => {
                        if (v) {
                            this.categoryValues = v;
                        } else {
                            this.categoryValues = [];
                        }
                    })
                );
                break;
            }
            case "CUSTOM_RSS": {
                this.initCustomRss();
                break;
            }

            default: {
                break;
            }
        }
    }

    override componentInit() {
        super.componentInit();
        this.cod(
            this.storeSelector.getScenes(true).subscribe((i_scenes) => {
                let player = this.storeSelector.getBlockLabelById(this.sceneItem.$.player);
                const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
                const playerIsAliased = !compareIds(playerId, player.id);
                if (playerIsAliased) {
                    player = this.storeSelector.getBlockLabelById(playerId);
                }
                this.scenesSimple = [];

                i_scenes.forEach((scene) => {
                    if (player.id === this.blockLabelRecords.JSON_VIEWER.id || player.id === this.blockLabelRecords.JSON_PLAYER.id) {
                        const s = {name: scene.Player.$.label, sceneId: scene.Player.$.id};
                        if (this.sceneItem.Data[0]?.Json?.[0]?.Player?.[0]?.$.src === scene.Player.$.id) this.assignedScene = s;
                        return this.scenesSimple.push(s);
                    }

                    if (player.types.findIndex((v) => v === scene.Player.$.mimeType) > -1) {
                        const o = {name: scene.Player.$.label, sceneId: scene.Player.$.id};
                        this.scenesSimple.push(o);

                        switch (this.handleMimeAnomalies()) {
                            case "STOCKS": {
                                if (this.sceneItem.Data[0]?.Stocks?.[0]?.Player && this.sceneItem.Data[0].Stocks[0].Player[0]?.$?.src === scene.Player.$.id) this.assignedScene = o;
                                break;
                            }
                            case "XML": {
                                if (this.sceneItem.Data[0]?.Xml?.[0]?.Player && this.sceneItem.Data[0].Xml[0].Player[0]?.$?.src === scene.Player.$.id) this.assignedScene = o;
                                break;
                            }
                            case "CATALOG": {
                                if (this.sceneItem.Data[0]?.Catalog?.[0]?.Player[0]?.$?.src === scene.Player.$.id)
                                    this.assignedScene = o;
                                if (this.sceneItem.Data[0]?.Catalog?.[0]?.Categories[0]?.Category) {
                                    this.selectedCategories = _.cloneDeep(this.sceneItem.Data[0]?.Catalog?.[0]?.Categories[0]?.Category);
                                } else {
                                    this.selectedCategories = [];
                                }
                                if (!this.categoryTreeItems || this.categoryTreeItems.length == 0) {
                                    this.categoryTreeItems = this.buildCheckboxTreeData(this.categoryValues);
                                }
                                break;
                            }
                            case "CUSTOM_RSS": {
                                if (this.sceneItem.Data[0].Rss[0].CustomRss[0]?.Player[0]?.$?.src === scene.Player.$.id)
                                    this.assignedScene = o;
                                break;
                            }
                            default: {
                                if (this.sceneItem.Data?.[0]?.Json?.[0]?.Player?.[0]?.$?.src === scene.Player.$.id) this.assignedScene = o;
                                break;
                            }
                        }
                    }
                });
            })
        );
    }

    override componentStoreUpdates() {
        this.componentStoreUpdatesForm();
        super.componentStoreUpdates();
        this.cd.markForCheck();
    }

    @timeout()
    componentStoreUpdatesForm() {
        switch (this.handleMimeAnomalies()) {
            case "STOCKS": {
                this.dynamicFormComponent.ignoreValidation = true;
                this.componentStoreUpdatesFormSetJsonConfig();
                break;
            }
            case "XML": {
                this.dynamicFormComponent.ignoreValidation = true;
                this.componentStoreUpdatesFormSetJsonConfig();
                break;
            }
            case "CATALOG": {
                this.dynamicFormComponent.ignoreValidation = true;
                this.componentStoreUpdatesFormSetJsonConfig();
                break;
            }
            case "CUSTOM_RSS": {
                this.dynamicFormComponent.ignoreValidation = true;
                this.componentStoreUpdatesFormSetJsonConfig();
                /** embedded **/
                if (this.sceneItem.Data[0].Rss[0].CustomRss[0].$.url === 'null') {
                    this.setFormValue('feed', 'embedded');
                    this.setCustomRssStatusUI('embedded');
                } else {
                    const foundIndex = this.rssNames.findIndex((v) => v.optionValue === this.sceneItem.Data[0].Rss[0].CustomRss[0].$.url);
                    if (foundIndex === -1) {
                        this.setFormValue('feed', 'custom');
                        if (isNullOrUndef(this.sceneItem.Data[0].Rss[0]?.$?.url)) {
                            this.setFormValue('url', this.sceneItem.Data[0].Rss[0].CustomRss[0].$.url);
                        }
                        // this.onChangeCustomRssFeed(null);
                    }
                    this.setCustomRssStatusUI('');
                }
                break;
            }

            case "JSON": {
                this.componentStoreUpdatesFormSetJsonConfig();
                break;
            }
        }
        this.cd.markForCheck();
    }

    componentStoreUpdatesFormSetJsonConfig() {
        let mode;
        switch (this.handleMimeAnomalies()) {
            case "STOCKS": {
                mode = this.sceneItem?.Data?.[0]?.Stocks?.[0]?.$?.displayMode;
                this.sceneItem?.Data?.[0]?.Stocks?.[0]?.$?.refreshEnabled === '0' ? this.setUiDisableInput('minRefreshTime', true) : this.setUiDisableInput('minRefreshTime', false);
                break;
            }
            case "XML": {
                mode = this.sceneItem?.Data?.[0]?.Xml?.[0]?.$?.displayMode;
                this.sceneItem?.Data?.[0]?.Xml?.[0]?.$?.refreshEnabled === '0' ? this.setUiDisableInput('minRefreshTime', true) : this.setUiDisableInput('minRefreshTime', false);
                break;
            }
            case "CATALOG": {
                mode = this.sceneItem?.Data?.[0]?.Catalog?.[0]?.$?.displayMode;
                this.sceneItem?.Data?.[0]?.Catalog?.[0]?.$?.refreshEnabled === '0' ? this.setUiDisableInput('minRefreshTime', true) : this.setUiDisableInput('minRefreshTime', false);
                break;
            }
            case "CUSTOM_RSS": {
                mode = this.sceneItem.Data[0].Rss[0].CustomRss[0].$.displayMode;
                if (this.sceneItem.Data[0]?.Rss?.[0]?.$?.refreshEnabled) {
                    this.sceneItem.Data[0].Rss[0].$.refreshEnabled === '0' ? this.setUiDisableInput('minRefreshTime', true) : this.setUiDisableInput('minRefreshTime', false);
                }
                break;
            }
            case "JSON": {
                mode = this.sceneItem?.Data?.[0]?.Json?.[0]?.$?.displayMode;
                this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$?.mode === 'offset' ? this.setUiConfigHide('startDate', true) : this.setUiConfigHide('startDate', false);
                this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$?.mode === 'offset' ? this.setUiConfigHide('endDate', true) : this.setUiConfigHide('endDate', false);
                this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$?.mode === 'fixed' ? this.setUiConfigHide('before', true) : this.setUiConfigHide('before', false);
                this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$?.mode === 'fixed' ? this.setUiConfigHide('after', true) : this.setUiConfigHide('after', false);
                break;
            }
        }
        if (mode === 'carousel' || mode === 'list') {
            this.setUiConfigHide('handle', true);
            this.setUiConfigHide('itemInterval', true);
            this.setUiConfigHide('playVideoInFull', true);
            this.setUiConfigHide('dragDropEnabled', false);
            this.setUiConfigHide('vertical', false);
        } else if (mode === 'manual') {
            this.setUiConfigHide('handle', false);
            this.setUiConfigHide('itemInterval', true);
            this.setUiConfigHide('playVideoInFull', true);
            this.setUiConfigHide('dragDropEnabled', true);
            this.setUiConfigHide('vertical', true);
        } else if (mode === 'slideShow') {
            this.setUiConfigHide('handle', false);
            this.setUiConfigHide('itemInterval', false);
            this.setUiConfigHide('playVideoInFull', false);
            this.setUiConfigHide('dragDropEnabled', true);
            this.setUiConfigHide('vertical', true);
        }
    }

    initCustomRss() {
        Object.keys(rssLinks).forEach(field => {
            this.rssNames.push({
                optionsLabel: rssLinks[field],
                optionValue: field,
                optionType: 'text'
            });
        });
        this.tableColumns = [{
            inputType: 'edit',
            name: 'title',
            maxStringSize: '16'
        }, {
            inputType: 'edit',
            name: 'description',
            maxStringSize: '10'
        }];
        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    override initRegisterDynamic() {
        const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
        const refreshEnabled: FieldConfig = {
            type: "checkbox",
            value: '1',
            label: this.translocoService.translate('general.requestData', {}, this.translocoService.getActiveLang()),
            inputType: "text",
            name: "refreshEnabled",
            ignoreMissingValue: true,
            storePath: 'Data[0].Json[0].$.refreshEnabled'
        };

        const randomOrder: FieldConfig = {
            type: "checkbox",
            value: '1',
            label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
            inputType: "text",
            name: "randomOrder",
            ignoreMissingValue: true,
            storePath: 'Data[0].Json[0].$.randomOrder'
        };

        const minRefreshTime: FieldConfig = {
            type: "input",
            value: '30',
            label: this.translocoService.translate('general.minutes', {}, this.translocoService.getActiveLang()),
            min: '2',
            max: '1440',
            step: '1',
            minMaxDefault: '30',
            inputType: "number",
            name: "minRefreshTime",
            storePath: 'Data[0].Json[0].$.minRefreshTime',
            validations: [
                {
                    name: "required",
                    validator: Validators.required,
                    message: "value required"
                },
                {
                    name: "pattern",
                    validator: Validators.pattern(/^\d*\.?\d*$/),
                    // validator: Validators.pattern("^[a-zA-Z]+$"),
                    message: "Accept only numbers"
                }
            ]
        };

        // const intervalEnabled: FieldConfig = {
        //     type: "checkbox",
        //     value: '0',
        //     label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
        //     inputType: "text",
        //     name: "intervalEnabled",
        //     storePath: 'Data[0].Json[0].$.intervalEnabled'
        // };

        const itemInterval: FieldConfig = {
            type: "input",
            value: '60',
            label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
            inputType: "number",
            min: 1,
            max: 86400,
            minMaxDefault: '60',
            step: 1,
            name: "itemInterval",
            storePath: 'Data[0].Json[0].$.itemInterval'
        };
        const displayMode: FieldConfig = {
            type: "select",
            label: this.translocoService.translate('general.displayType', {}, this.translocoService.getActiveLang()),
            name: "displayMode",
            value: "",
            ignoreMissingValue: true,
            options: [
                {
                    optionValue: "manual",
                    optionType: "text",
                    optionsLabel: "manual"
                },
                {
                    optionValue: "slideShow",
                    optionType: "text",
                    optionsLabel: "slide show"
                },
                {
                    optionValue: "list",
                    optionType: "text",
                    optionsLabel: "list"
                }
            ],
            storePath: 'Data[0].Json[0].$.displayMode'
        };
        const dragDropEnabled: FieldConfig = {
            type: "checkbox",
            value: '1',
            label: this.translocoService.translate('general.dragDropEnabled2', {}, this.translocoService.getActiveLang()),
            inputType: "text",
            name: "dragDropEnabled",
            ignoreMissingValue: true,
            storePath: 'Data[0].Json[0].$.dragDropEnabled'
        };
        const transitionPool: FieldConfig = {
            type: "select",
            label: this.translocoService.translate('general.transitionPool', {}, this.translocoService.getActiveLang()),
            name: "handle",
            value: "",
            options: [],
            observable: this.storeSelector.getTransitionPools(),
            optionValue: "id",
            optionLabel: "transition_pool_name",
            defaultOption: {value: '', label: 'None'},
            storePath: 'Data[0].TransitionPool[0].$.handle'
        };
        const playVideoInFull: FieldConfig = {
            type: "checkbox",
            value: '1',
            label: this.translocoService.translate('general.playVideoToEnd', {}, this.translocoService.getActiveLang()),
            inputType: "text",
            name: "playVideoInFull",
            ignoreMissingValue: true,
            storePath: 'Data[0].Json[0].$.playVideoInFull'
        };

        const volume: FieldConfig = {
            type: "input",
            value: '1',
            label: this.translocoService.translate('general.volume', {}, this.translocoService.getActiveLang()),
            inputType: "range",
            min: 0,
            max: 1,
            step: 0.1,
            name: "volume",
            storePath: 'Data[0].Json[0].$.volume'
        };

        // const verticalRadio: FieldConfig = {
        //     type: "radiobutton",
        //     label: this.translocoService.translate('general.direction', {}, this.translocoService.getActiveLang()),
        //     name: "vertical",
        //     options: ["vertical", "horizontal"],
        //     value: "vertical",
        //     storePath: 'Data[0].Json[0].$.vertical'
        // };
        const verticalDropdown: FieldConfig = {
            type: "select",
            label: this.translocoService.translate('general.direction', {}, this.translocoService.getActiveLang()),
            name: "vertical",
            value: "",
            options: [
                {
                    optionValue: "0",
                    optionType: "text",
                    optionsLabel: "horizontal"
                },
                {
                    optionValue: "1",
                    optionType: "text",
                    optionsLabel: "vertical"
                }
            ],
            storePath: ''
        };

        switch (playerId) {
            case this.blockLabelRecords.STOCKS.id: {
                this.uiConfigInit = [
                    {
                        type: "input",
                        value: "",
                        label: this.translocoService.translate('general.symbols', {}, this.translocoService.getActiveLang()),
                        inputType: "textarea",
                        name: "Symbols",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Stocks[0].Symbols[0]'
                    },
                    this.setStorePath(displayMode, 'Data[0].Stocks[0].$.displayMode'),
                    this.setStorePath(refreshEnabled, 'Data[0].Stocks[0].$.refreshEnabled'),
                    this.setStorePath(minRefreshTime, 'Data[0].Stocks[0].$.minRefreshTime'),
                    this.setStorePath(itemInterval, 'Data[0].Stocks[0].$.itemInterval'),
                    this.setStorePath(randomOrder, 'Data[0].Stocks[0].$.randomOrder'),
                    this.setStorePath(verticalDropdown, 'Data[0].Stocks[0].$.vertical'),
                    {
                        type: "input",
                        value: '1',
                        label: this.translocoService.translate('general.speed', {}, this.translocoService.getActiveLang()) + ' (legacy)',
                        inputType: "number",
                        min: 1,
                        max: 999,
                        step: 1,
                        name: "speed",
                        storePath: 'Data[0].Stocks[0].$.speed'
                    }
                ];
                this.calcTotalStocksSymbols();
                return;
            }

            case this.blockLabelRecords.XML.id: {
                this.uiConfigInit = [
                    this.setStorePath(displayMode, 'Data[0].Xml[0].$.displayMode'),
                    this.setStorePath(verticalDropdown, 'Data[0].Xml[0].$.vertical'),
                    this.setStorePath(playVideoInFull, 'Data[0].Xml[0].$.playVideoInFull'),
                    this.setStorePath(refreshEnabled, 'Data[0].Xml[0].$.refreshEnabled'),
                    this.setStorePath(minRefreshTime, 'Data[0].Xml[0].$.minRefreshTime'),
                    this.setStorePath(itemInterval, 'Data[0].Xml[0].$.itemInterval'),
                    this.setStorePath(randomOrder, 'Data[0].Xml[0].$.randomOrder'),
                    this.setStorePath(volume, 'Data[0].Xml[0].$.volume'),
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.itemsPath2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "itemsPath",
                        storePath: 'Data[0].Xml[0].$.itemsPath'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "url",
                        storePath: 'Data[0].Xml[0].$.url'
                    }
                ];
                return;
            }
            case this.blockLabelRecords.CATALOG.id: {
                this.uiConfigInit = [
                    this.setStorePath(displayMode, 'Data[0].Catalog[0].$.displayMode'),
                    this.setStorePath(verticalDropdown, 'Data[0].Catalog[0].$.vertical'),
                    this.setStorePath(playVideoInFull, 'Data[0].Catalog[0].$.playVideoInFull'),
                    this.setStorePath(randomOrder, 'Data[0].Catalog[0].$.randomOrder'),
                    this.setStorePath(refreshEnabled, 'Data[0].Catalog[0].$.refreshEnabled'),
                    this.setStorePath(minRefreshTime, 'Data[0].Catalog[0].$.minRefreshTime'),
                    this.setStorePath(itemInterval, 'Data[0].Catalog[0].$.itemInterval'),
                ];
                return;
            }
            case this.blockLabelRecords.CUSTOMRSS.id: {
                let urlDisabled = false;
                const url = this.sceneItem.Data[0]?.Rss?.[0]?.$?.url;
                if (url) {
                    Object.keys(rssLinks).forEach(field => {
                        if (field === url) {
                            urlDisabled = true;
                        }
                    });
                }
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.feed', {}, this.translocoService.getActiveLang()),
                        name: "feed",
                        value: "",
                        options: this.rssNames,
                        storePath: 'Data[0].Rss[0].CustomRss[0].$.url',
                        ignoreMissingValue: true,
                        detectChange: true,
                        callBackEvent: (formValue) => {
                            this.onChangeCustomRssFeed(formValue);
                        }
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "url",
                        disabled: urlDisabled,
                        storePath: 'Data[0].Rss[0].$.url'
                    },
                    {
                        type: "input",
                        label: '',
                        name: "item",
                        inputType: 'tablelist',
                        tableColumns: this.tableColumns,
                        cloneVals: true,
                        multiSelect: false,
                        rememberSelection: true,
                        allowFilter: true,
                        buttonBarClassName: 'blockJsonButtonBar',
                        buttons: this.buttons,
                        inputEditFormat: {title: 'text', description: 'text'},
                        callBackEvent: (v) => this.onTableListChangeCallBack(v),
                        callBackValue: (item, direction) => {
                            switch (direction) {
                                case 'IN': {
                                    item.$ = {title: item.title[0], description: item.description[0]};
                                    delete item.title;
                                    delete item.description;
                                    return item;
                                }
                                case 'OUT': {
                                    item.title = [item.$.title];
                                    item.description = [item.$.description];
                                    delete item.$;
                                    return item;
                                }
                            }
                        },
                        inputEditRenamePath: [{path: '$.title', key: 'title'}, {path: '$.description', key: 'description'}],
                        storePath: 'Data[0].Rss[0].rss[0].channel[0].item',
                        expandableEditor: true,
                        // callBackEvent: (v) => this.onTableListChangeCallBack(v)
                    },
                    this.setStorePath(displayMode, 'Data[0].Rss[0].CustomRss[0].$.displayMode'),
                    this.setStorePath(verticalDropdown, 'Data[0].Rss[0].CustomRss[0].$.vertical'),
                    this.setStorePath(playVideoInFull, 'Data[0].Rss[0].CustomRss[0].$.playVideoInFull'),
                    this.setStorePath(volume, 'Data[0].Rss[0].CustomRss[0].$.volume'),
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.requestData', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "refreshEnabled",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Rss[0].$.refreshEnabled'
                    },
                    {
                        type: "input",
                        value: '30',
                        label: this.translocoService.translate('general.minutes', {}, this.translocoService.getActiveLang()),
                        min: '2',
                        max: '1440',
                        minMaxDefault: '30',
                        step: '1',
                        inputType: "number",
                        name: "minRefreshTime",
                        storePath: 'Data[0].Rss[0].$.minRefreshTime',
                        validations: [
                            {
                                name: "required",
                                validator: Validators.required,
                                message: "value required"
                            },
                            {
                                name: "pattern",
                                validator: Validators.pattern(/^\d*\.?\d*$/),
                                // validator: Validators.pattern("^[a-zA-Z]+$"),
                                message: "Accept only numbers"
                            }
                        ]
                    },
                    this.setStorePath(itemInterval, 'Data[0].Rss[0].CustomRss[0].$.itemInterval'),
                    this.setStorePath(randomOrder, 'Data[0].Rss[0].$.randomOrder'),
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.link', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "link",
                        storePath: 'Data[0].Rss[0].CustomRss[0].$.url'
                    }
                ];
                return;
            }

            case this.blockLabelRecords.JSON_PLAYER.id: {
                // NETFEED
                // if (this.sceneItem.Data[0].Json[0]?.Data?.[0]?.$.token === this.blockLabelRecords...'4300.1') {
                // if (this.transitionsEnabled === '1') {
                //     this.uiConfigInit.push(transitionPool);
                // }
                this.uiConfigInit = [
                    displayMode,
                    playVideoInFull,
                    this.setStorePath(volume, 'Data[0].Json[0].$.volume'),
                    this.setStorePath(verticalDropdown, 'Data[0].Json[0].$.vertical'),
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },

                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },

                ];
                if (this.transitionsEnabled === '1') {
                    this.uiConfigInit.push(transitionPool);
                }
                break;
            }
            case this.blockLabelRecords.JSON_VIEWER.id: {
                this.uiConfigInit = [
                    {
                        type: "checkbox",
                        value: '0',
                        label: this.translocoService.translate('general.requestData', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "refreshEnabled",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.refreshEnabled'
                    }, {
                        type: "input",
                        value: '30',
                        label: this.translocoService.translate('general.minutes', {}, this.translocoService.getActiveLang()),
                        min: '0.1',
                        max: '1440',
                        minMaxDefault: '30',
                        step: '0.1',
                        inputType: "number",
                        name: "minRefreshTime",
                        storePath: 'Data[0].Json[0].$.minRefreshTime',
                        validations: [
                            {
                                name: "required",
                                validator: Validators.required,
                                message: "value required"
                            },
                            {
                                name: "pattern",
                                validator: Validators.pattern(/^\d*\.?\d*$/),
                                // validator: Validators.pattern("^[a-zA-Z]+$"),
                                message: "Accept only numbers"
                            }
                        ]
                    },
                    volume
                ];
                if (this.transitionsEnabled === '1') {
                    this.uiConfigInit.push(transitionPool);
                }
                break;
            }

            case this.blockLabelRecords.IFTTT.id: {
                this.uiConfigInit = [
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    displayMode,
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                ];
                break;
            }
            case this.blockLabelRecords.INSTAGRAM_FEED.id:
            case this.blockLabelRecords.INSTAGRAM_MEDIA.id: {
                this.tokenized = true;
                this.uiConfigInit = [
                    displayMode,
                    volume,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                ];
                break;
            }
            case this.blockLabelRecords.PINTEREST_BOARD.id: {
                this.uiConfigInit = [
                    playVideoInFull,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.board', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "board",
                        storePath: 'Data[0].Json[0].Data[0].$.board'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.user', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "key",
                        storePath: 'Data[0].Json[0].Data[0].$.key'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                    displayMode
                ];
                break;
            }
            case this.blockLabelRecords.PINTEREST_USER.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.board', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "board",
                        storePath: 'Data[0].Json[0].Data[0].$.board'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.key', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "key",
                        storePath: 'Data[0].Json[0].Data[0].$.key'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },

                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.TUMBLRPHOTOS.id:
            case this.blockLabelRecords.TUMBLRPOSTS.id:
            case this.blockLabelRecords.TUMBLRVIDEOS.id:
            case this.blockLabelRecords.TUMBLRTEXTS.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },
                    playVideoInFull
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }
                ];
                break;
            }
            case this.blockLabelRecords.FACEBOOK_ALBUM.id: {
                this.tokenType = 'album';
                this.tokenized = false;
                this.serverEndPoint = 'facebook/getAlbums/:TOKEN:';
                this.childEndPoint = 'facebook/getAlbums/:TOKEN:/:TOKEN1:';
                this.refreshToken(true);
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token',
                        disabled: true
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.FACEBOOK_WALL.id:
            case this.blockLabelRecords.FACEBOOK_VIDEO.id: {
                this.refreshToken(true);
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token',
                        disabled: true
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.ETSY_USER.id:
            case this.blockLabelRecords.ETSY_SHOP.id:
            case this.blockLabelRecords.ETSY_LIST.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.shop', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "shop",
                        storePath: 'Data[0].Json[0].Data[0].$.shop'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },
                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.FIVEHUNDRED_USER.id:
            case this.blockLabelRecords.FIVEHUNDRED_COLLECTION.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },

                    dragDropEnabled,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.user', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "user",
                        storePath: 'Data[0].Json[0].Data[0].$.user'
                    },
                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.YELP_INFO.id:
            case this.blockLabelRecords.YELP_REVIEWS.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.business', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "key",
                        storePath: 'Data[0].Json[0].Data[0].$.key'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },

                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },

                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.WEATHER.id: {
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.addressZip', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "address",
                        storePath: 'Data[0].Json[0].Data[0].$.address'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.temperatureUnit', {}, this.translocoService.getActiveLang()),
                        name: "unit",
                        options: ["C", "F"],
                        value: "C",
                        storePath: 'Data[0].Json[0].Data[0].$.unit'
                    },
                    {
                        type: "radiobutton",
                        label: this.translocoService.translate('general.style', {}, this.translocoService.getActiveLang()),
                        name: "style",
                        skipFirst: true,
                        options: ["WillSkipSinceOneBased", "Black", "White", "Color"],
                        value: "Black",
                        storePath: 'Data[0].Json[0].Data[0].$.style'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }
                ];
                break;
            }
            case this.blockLabelRecords.FLICKR.id: {
                // this.serverEndPoint = 'GoogleSheetsList/:TOKEN:';
                // this.childEndPoint = 'GoogleSheetsList/:TOKEN:/:TOKEN1:';
                // this.refreshToken(false);
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "button",
                        value: this.translocoService.translate('general.createToken', {}, this.translocoService.getActiveLang()),
                        inputType: "standard",
                        label: this.translocoService.translate('general.insert', {}, this.translocoService.getActiveLang()),
                        icon: 'vpn_key',
                        name: "associateSomeFile",
                        callBackEvent: (v) => this.onCreateToken()
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }
                ];
                break;
            }
            case this.blockLabelRecords.SPREADSHEET.id: {
                this.tokenFieldName = 'sheet name';
                this.tokenized = true;
                this.tokenType = 'sheets';
                this.serverEndPoint = 'GoogleSheetsList/:TOKEN:';
                this.childEndPoint = 'GoogleSheetsList/:TOKEN:/:TOKEN1:';
                this.refreshToken(true);
                this.uiConfigInit = [
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    // {
                    //     type: "input",
                    //     value: '5',
                    //     label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                    //     inputType: "number",
                    //     disabled: false,
                    //     name: "itemInterval",
                    //     storePath: 'Data[0].Json[0].$.itemInterval'
                    // },
                    // {
                    //     type: "checkbox",
                    //     value: '1',
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     inputType: "text",
                    //     name: "randomOrder",
                    //     ignoreMissingValue: true,
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }
                ];
                break;
            }
            case this.blockLabelRecords.DROPBOX.id: {
                this.tokenized = true;
                this.tokenType = 'dropbox';
                this.serverEndPoint = 'DropboxFolders/:TOKEN:/';
                this.childEndPoint = 'DropboxFolders/:TOKEN:/:TOKEN1:';
                this.refreshToken(true);
                this.uiConfigInit = [
                    displayMode,
                    volume,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.filter', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "filter",
                        storePath: 'Data[0].Json[0].Data[0].$.filter'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },

                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.DRIVE.id: {
                this.tokenized = true;
                this.tokenType = 'drive';
                this.tokenFieldName = 'folder';
                this.serverEndPoint = 'GoogleDriveFolders/:TOKEN:/root';
                this.childEndPoint = 'GoogleDriveFolders/:TOKEN:/:TOKEN1:';
                this.refreshToken(true);
                this.uiConfigInit = [
                    displayMode,
                    volume,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.filter', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "filter",
                        storePath: 'Data[0].Json[0].Data[0].$.filter'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    },
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // },

                    playVideoInFull,
                ];
                break;
            }
            case this.blockLabelRecords.CALENDAR.id: {
                this.tokenFieldName = 'calendar name';
                this.tokenized = true;
                this.tokenType = 'calendar';
                this.serverEndPoint = 'GoogleCalendarList/:TOKEN:/100';
                this.childEndPoint = 'GoogleCalendarList/:TOKEN:/:TOKEN1:';
                this.refreshToken(true);
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.mode', {}, this.translocoService.getActiveLang()),
                        name: "mode",
                        value: "field",
                        options: ["fixed", "offset"],
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].Data[0].$.mode'
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.daysBeforeToday', {}, this.translocoService.getActiveLang()),
                        name: "before",
                        value: '1',
                        min: '0',
                        max: '9999',
                        inputType: "number",
                        storePath: 'Data[0].Json[0].Data[0].$.before'
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.daysAfterToday', {}, this.translocoService.getActiveLang()),
                        name: "after",
                        value: '1',
                        min: '0',
                        max: '9999',
                        inputType: "number",
                        storePath: 'Data[0].Json[0].Data[0].$.after'
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.startDate', {}, this.translocoService.getActiveLang()),
                        name: "startDate",
                        value: '1',
                        ignoreMissingValue: true,
                        inputType: "date",
                        storePath: 'Data[0].Json[0].Data[0].$.startDate'
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.endDate', {}, this.translocoService.getActiveLang()),
                        name: "endDate",
                        value: '1',
                        ignoreMissingValue: true,
                        inputType: "date",
                        storePath: 'Data[0].Json[0].Data[0].$.endDate'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                    // {
                    //     type: "radiobutton",
                    //     label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                    //     name: "randomOrder",
                    //     options: ["off", "on"],
                    //     value: "0",
                    //     storePath: 'Data[0].Json[0].$.randomOrder'
                    // }

                ];
                break;
            }
            case this.blockLabelRecords.TWITTER.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            /** Ayrshare components **/

            case this.blockLabelRecords.X_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.GOOGLE_BUSINESS_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.INSTAGRAM_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.FACEBOOK_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.FACEBOOK_GROUPS_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.REDDIT_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.LINKEDIN_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.TIKTOK_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.YOUTUBE_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.PINTEREST_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
            case this.blockLabelRecords.TELEGRAM_AYRSHARE.id: {
                this.socialized = true;
                this.uiConfigInit = [
                    displayMode,
                    refreshEnabled,
                    minRefreshTime,
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.accessToken', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "token",
                        disabled: true,
                        storePath: 'Data[0].Json[0].Data[0].$.token'
                    },
                    {
                        type: "input",
                        value: '5',
                        label: this.translocoService.translate('general.itemIntervalSeconds', {}, this.translocoService.getActiveLang()),
                        min: 1,
                        max: 86400,
                        minMaxDefault: '60',
                        inputType: "number",
                        disabled: false,
                        name: "itemInterval",
                        storePath: 'Data[0].Json[0].$.itemInterval'
                    },
                    {
                        type: "checkbox",
                        value: '1',
                        label: this.translocoService.translate('general.randomOrder2', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "randomOrder",
                        ignoreMissingValue: true,
                        storePath: 'Data[0].Json[0].$.randomOrder'
                    }
                ];
                break;
            }
        }
        this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }

    override initApplyStoreToDynamic(applyStoreToDynamic: boolean = false) {
        super.initApplyStoreToDynamic(applyStoreToDynamic);
    }

    override submit(formValues) {
        switch (this.handleMimeAnomalies()) {
            case "CUSTOM_RSS": {
                super.submit(formValues, (values) => {
                    const swappedValues = this.swapKeyName(values, 'link', 'url');
                    switch (formValues.feed) {
                        case 'custom': {
                            const idx = swappedValues.findIndex((a1) => {
                                return a1.storePath == 'Data[0].Rss[0].rss[0].channel[0]';
                            });
                            if (idx > -1) {
                                swappedValues.splice(idx, 1);
                            }
                            return swappedValues;
                        }
                        case 'embedded': {
                            return swappedValues;
                        }
                        default: {
                            const index1 = values.findIndex((a1) => {
                                return a1.storePath == 'Data[0].Rss[0].CustomRss[0].$';
                            });
                            const index2 = values.findIndex((a2) => {
                                return a2.storePath == 'Data[0].Rss[0].$';
                            });
                            if (index1 === -1 || index2 === -1) {
                                return swappedValues;
                            }
                            values[index2].value = values[index1].value;
                            return swappedValues;

                        }
                    }
                });
                break;
            }

            case "STOCKS": {
                if (!isArray(formValues.Symbols)) {
                    formValues.Symbols = [formValues.Symbols];
                }
                if (isNullOrUndefOrEmpty(formValues.Symbols?.[0])) {
                    formValues.Symbols = this.defaultStocks;
                    this.calcTotalStocksSymbols();
                    this.formValuesSubmit(formValues);
                    return;
                }
                let stocks = formValues.Symbols[0].split(',');
                stocks = stocks.filter(elm => !isNullOrUndefOrEmpty(elm));
                stocks = stocks.join(',');
                formValues.Symbols = [stocks];
                this.totalStockSymbols = formValues.Symbols[0].split(',').length;
                this.formValuesSubmit(formValues);
                break;
            }
            case "JSON":
            default: {
                this.formValuesSubmit(formValues);
                break;
            }
        }
    }

    private removedEmbedded() {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'rss',
                value: [],
                storePath: 'Data[0].Rss[0]'
            }]
        });
    }

    private formValuesSubmit(i_formValues) {
        if (!i_formValues.VideoIdList) i_formValues.VideoIdList = '';
        if (!i_formValues.channel) i_formValues.channel = '';
        super.submit(i_formValues);
    }

    private onSubmitNetFeedNews(formValues) {
        const foundIndex = this.netFeedNewsLinks.findIndex((v) => v.optionValue === formValues.feed);
        if (foundIndex === -1) return;
        formValues.itemsPath = this.netFeedNewsLinks[foundIndex].itemsPath;
    }

    private onSubmitNetFeedHoroscope(formValues) {
        const foundIndex = this.netFeedHoroscopeLinks.findIndex((v) => v.optionValue === formValues.feed);
        if (foundIndex === -1) return;
        formValues.itemsPath = this.netFeedHoroscopeLinks[foundIndex].itemsPath;
    }

    /**
     * Change custom rss form show/hide status according to feed
     * @param feed
     */
    private setCustomRssStatusUI(feed) {
        // added 10-25-23 now always hiding link in UI
        this.setUiConfigHide('link', true);

        if (feed === 'embedded') {
            this.setUiConfigHide('item', false);
            this.setUiConfigHide('url', true);
            // this.setUiConfigHide('link', true);
        } else {
            this.setUiConfigHide('item', true);
            this.setUiConfigHide('url', false);
            // this.setUiConfigHide('link', false);
        }
    }

    /**
     * When select feed, update url, link and field status
     * @param formValues
     * @returns
     */
    private onChangeCustomRssFeed(formValues) {
        let url = 'http://www...';
        let link = 'http://www...';
        let isEmbedded = false;
        switch (formValues.feed) {
            case 'custom': {
                const foundIndex = this.rssNames.findIndex((v) => v.optionValue === formValues.url);
                this.setUiDisableInput('url', false);
                if (foundIndex > -1) {
                    formValues.url = 'http://www...';
                    formValues.link = 'http://www...';
                } else {
                    formValues.url = !isNullOrUndefOrEmpty(formValues.url) && formValues.url !== 'null' ? formValues.url : 'http://www...';
                    formValues.link = !isNullOrUndefOrEmpty(formValues.link) && formValues.link !== 'null' ? formValues.link : 'http://www...';
                }
                break;
            }
            case 'embedded': {
                url = 'null';
                link = 'null';
                isEmbedded = true;
                break;
            }
            default: {
                this.setUiDisableInput('url', true);
                url = formValues.feed;
                link = formValues.feed;
                break;
            }
        }
        this.setFormValue("url", url);
        this.setFormValue("link", link);
        this.setCustomRssStatusUI(formValues.feed);
        if (!isEmbedded) {
            /** not embedded, need to remove embedded slice **/
            setTimeout(() => {
                this.removedEmbedded();
            }, 333);
        }
    }

    private onTableListChangeCallBack(e: ITableListEvent) {
        if (e.currentAction === 'added') {
            const values = _.cloneDeep(e.values);
            values.push({'title': ['...'], 'description': ['...']});
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'item',
                    value: values,
                    storePath: 'Data[0].Rss[0].rss[0].channel[0]'
                }]
            });
            super.initApplyStoreToDynamic(true);
        }
    }

    private handleMimeAnomalies(): MimeAnomalyType {

        // const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);

        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.STOCKS.id: {
                return 'STOCKS';
            }
            case this.blockLabelRecords.XML.id: {
                return 'XML';
            }
            case this.blockLabelRecords.CATALOG.id: {
                return 'CATALOG';
            }
            case this.blockLabelRecords.CUSTOMRSS.id: {
                return 'CUSTOM_RSS';
            }
            default: {
                return 'JSON';
            }
        }
    }

    onBindingChangeTokenFolder(val) {
        if (!val) return;
        let values = [{
            key: 'path',
            value: val?.path,
            storePath: `Data[0].Json[0].Data[0].$`
        }];
        switch (this.tokenType) {
            case 'drive':
            case 'sheets':
            case 'calendar': {
                values = [{
                    key: 'id',
                    value: val?.id,
                    storePath: `Data[0].Json[0].Data[0].$`
                }];
                break;
            }
            default: {
                values = [{
                    key: 'path',
                    value: val?.path,
                    storePath: `Data[0].Json[0].Data[0].$`
                }];
            }
        }
        // const values = [{
        //     key: 'path',
        //     value: val?.path,
        //     storePath: `Data[0].Json[0].Data[0].Data[0].$`
        // }];
        // if (this.tokenType == 'drive') {
        //     values.push({
        //         key: 'id',
        //         value: val?.id,
        //         storePath: `Data[0].Json[0].Data[0].$`
        //     });
        // }

        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values
        });
    }

    onSceneChange(e) {
        let storePath;
        let key;
        switch (this.handleMimeAnomalies()) {
            case "STOCKS": {
                key = 'src';
                storePath = `Data[0].Stocks[0].Player[0].$`;
                break;
            }
            case "XML": {
                key = 'src';
                storePath = `Data[0].Xml[0].Player[0].$`;
                break;
            }
            case "CATALOG": {
                key = 'src';
                storePath = `Data[0].Catalog[0].Player[0].$`;
                break;
            }
            case "CUSTOM_RSS": {
                key = 'src';
                storePath = `Data[0].Rss[0].CustomRss[0].Player[0].$`;
                break;
            }

            // case "NETFEED_HOROSCOPE":
            // case "NETFEED_NEWS": {
            //     key = 'src';
            //     storePath = `Data[0].Json[0].Player[0].$`;
            //     break;
            // }

            case "JSON": {
                key = 'src';
                storePath = `Data[0].Json[0].Player[0].$`;
                break;
            }
        }
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key,
                value: e.value.sceneId,
                storePath
            }]
        });
    }

    refreshToken(silent: boolean) {
        const token = this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$?.token;
        if (!token || token.length < 10) {
            if (!silent) this.toastr.error(this.translocoService.translate('toast.enterValidToken', {}, this.translocoService.getActiveLang()));
            return false;
        }
        if (silent) {
            this.resetTokenValue(this.sceneItem?.Data?.[0]?.Json?.[0]?.Data?.[0]?.$);
            // this.loadRemoteData(token, {});
        }
        return true;
    }

    openSceneEditor() {
        if (isNullOrUndefOrEmpty(this.assignedScene)) return this.toastr.error(this.translocoService.translate('general.notSceneAssigned', {}, this.translocoService.getActiveLang()));
        this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.sceneId}));
        this.router.navigateByUrl(`/editor/scene/${this.assignedScene.sceneId}`);
        // const areYouSure = this.translocoService.translate('message.areYouSureLeaveScene', {}, this.translocoService.getActiveLang());
        // return super.openDialog(areYouSure, {showCancel: true}, (r) => {
        //     if (r) {
        //
        //     }
        // });
    }

    onCreateToken() {
        let win: any;
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.DRIVE.id:
            case this.blockLabelRecords.CALENDAR.id:
            case this.blockLabelRecords.SPREADSHEET.id: {
                // win = window.open('http://google.signage.me', '_blank');
                win = popupWindow({url: 'http://google.signage.me', title: 'google', h: '650', w: '600'});
                break;
            }
            case this.blockLabelRecords.DROPBOX.id: {
                // win = window.open('http://dropbox.signage.me', '_blank');
                win = popupWindow({url: 'http://dropbox.signage.me', title: 'dropbox', h: '650', w: '600'});
                break;
            }
            case this.blockLabelRecords.INSTAGRAM_MEDIA.id:
            case this.blockLabelRecords.INSTAGRAM_FEED.id: {
                // win = window.open('http://instagram.signage.me', '_blank');
                win = popupWindow({url: 'http://instagram.signage.me', title: 'instagram', h: '650', w: '600'});
                break;
            }
            case this.blockLabelRecords.FLICKR.id: {
                // win = window.open('http://flickr.signage.me/', '_blank');
                win = popupWindow({url: 'http://flickr.signage.me', title: 'flickr', h: '650', w: '600'});
                break;
            }
        }
        if (win) {
            win.focus();
        } else {
            this.toastr.error(this.translocoService.translate('toast.browserPopOff', {}, this.translocoService.getActiveLang()));
        }
    }

    openSceneAssignmentDialog() {
        let player;
        const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
        player = this.storeSelector.getBlockLabelById(playerId);
        const dataDialog: IDialogGetAsset = {mode: "SCENE:MIME", mimeType: player.types[0]};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data: {
                ...dataDialog,
                callBack: (dialogGetAsset) => {
                    dialogRefVal.close();
                    this.onSceneChange({value: {sceneId: dialogGetAsset.selected}});
                }
            }
        });
        this.cod(
            dialogRefVal.afterClosed().pipe(take(1)).subscribe((r) => {
                if (!r) return;
                this.onSceneChange({value: {sceneId: r.selected}});
            })
        );
    }

    clearToken() {
        this.selectedTokenValue = {id: '', path: ''};
    }

    showTokenListTreeview() {
        if (!this.refreshToken(false) || !this.tokenType) {
            return;
        }
        this.toastr.info(this.translocoService.translate('toast.refreshList', {}, this.translocoService.getActiveLang()));
        const dialogRefVal = this.dialog.open(DialogTokenTreeviewComponent, {
            height: '400px',
            width: '350px',
            disableClose: true,
            data: {
                rootToken: this.sceneItem?.Data?.[0]?.Json[0]?.Data[0]?.$?.token,
                rootEndPoint: this.serverEndPoint,
                childEndPoint: this.childEndPoint,
                selectedItem: this.selectedTokenValue,
                tokenType: this.tokenType,
                callBack: (i_tokenItem) => {
                    dialogRefVal.close();
                    this.resetTokenValue(i_tokenItem);
                    this.onBindingChangeTokenFolder(i_tokenItem);
                }
            }
        });
    }

    /** Call back when category tree item is selected or not */
    onUpdateTreeSelection(e) {
        if (e && e.ids) {
            let data = this.selectedCategories;
            if (e.selected) {
                e.ids.forEach((_id) => {
                    if (this.selectedCategories.findIndex((v) => v.$.id == _id) == -1) {
                        data.push({
                            $: {
                                id: _id
                            }
                        });
                    }
                    if (data.length > 0) {
                        data = data.filter((item) => item.$.id != '-1');
                    }
                });
            } else {
                data = data.filter((item) => e.ids.indexOf(item.$.id) == -1);
                if (data.length == 0) {
                    data.push(
                        {
                            $: {
                                id: '-1'
                            }
                        }
                    );
                }
            }

            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Category',
                    value: data,
                    storePath: 'Data[0].Catalog.[0].Categories[0]'
                }]
            });
        }
    }

    /**
     * Build the file structure tree. The `items` is the Json object, or a sub-tree of a Json object.
     * The return value is the list of `CategoryCheckItemNode`.
     */
    buildCheckboxTreeData(items: ICategoryValues[], category_id = '-1', parent_id = 'parent_category_value_id'): ICategoryCheckItemNode[] {
        return items
            .filter(item => item[parent_id] == category_id)
            .map(item => {
                const node = new ICategoryCheckItemNode();
                node.id = item.category_values_id;
                node.item = item.category_value;
                node.selected = this.selectedCategories && this.selectedCategories.findIndex((v) => v.$.id == item.category_values_id) > -1;
                node.children = this.buildCheckboxTreeData(items, item.category_values_id);
                return node;
            });
    }

    appendDefaultStocks() {
        this.setFormValue('Symbols', this.defaultStocks);
        this.submit(this.form.value);
    }

    private setStorePath(i_field: FieldConfig, i_storePath: string): FieldConfig {
        const field = _.cloneDeep(i_field);
        field.storePath = i_storePath;
        return field;
    }

    private calcTotalStocksSymbols(formValues = null) {
        if (!formValues) {
            formValues = this.sceneItem.Data[0].Stocks[0];
        }
        this.totalStockSymbols = formValues.Symbols[0].split(',').length;
    }

    private resetTokenValue(value) {
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.SPREADSHEET.id:
            case this.blockLabelRecords.CALENDAR.id: {
                this.selectedTokenValue = {
                    id: value?.id,
                    path: value?.id
                };
                break;
            }
            default: {
                this.selectedTokenValue = {
                    id: value?.id,
                    path: value?.path
                };
            }
        }
    }
}

// getCustomRssBackwardsCompatible() {
//     if (this.sceneItem.Data[0].Rss[0]?.CustomRss) {
//         return this.sceneItem.Data[0].Rss[0].CustomRss[0];
//     } else {
//         return this.sceneItem.Data[0].Rss[0].CustomRss[0];
//     }
// }

// getCustomRssBackwardsCompatibleString(): string {
//     if (this.sceneItem.Data[0]?.Rss?.[0]?.CustomRss) {
//         return 'Data[0].Rss[0].CustomRss[0]';
//     } else {
//         return 'Data[0].Rss[0].CustomRss[0]';
//     }
// }


